module.exports = __webpack_public_path__ + "static/media/icon-png.54804558.svg";